const isEmptyRichText = (value?: string | null): boolean => {
  if (!value) return true;
  if (/<img/i.test(value)) return false;
  return !value
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
};

export default isEmptyRichText;
